// extracted by mini-css-extract-plugin
module.exports = {"container":"BU_container__3CBEr","wrapper":"BU_wrapper__PM9-Y","title":"BU_title__3UCee","text":"BU_text__3Hque","selectors":"BU_selectors__YzwI-","line":"BU_line__2tofJ"};